/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { Component, Input } from '@angular/core';
import { User } from '../../models/User';
import { TrackingService } from 'app/services/tracking.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MobileScrollService } from 'app/services/mobile-scroll.service';
import { AuthService } from 'app/services/auth.service';

@Component({
  selector: 'suggest-feedback',
  templateUrl: './suggest-feedback.component.html',
  styleUrls: ['./suggest-feedback.component.scss']
})
export class SuggestFeedbackComponent {
  @Input() metricPrettyName: string;
  @Input() metricId: string;
  @Input() type: string;
  @Input() id: string;

  description = '';
  email = '';

  get isAuthenticated() {
    return this.auth.isAuthenticated();
  }

  get uniqueIdPrefix() {
    if (!this.metricId) return 'suggest-feedback';
    return 'suggest-feedback-' + this.metricId.replace('.', '-');
  }

  get canSubmit() {
    if (this._userService.isAnonymous()) {
      return this.metricId && this.description && this.email;
    } else {
      return this.metricId && this.description;
    }
  }

  constructor(
    public _userService: User,
    public tracking: TrackingService,
    private modalService: NgbModal,
    private mobileScrollService: MobileScrollService,
    private auth: AuthService
  ) {}

  open(content) {
    if (!this.auth.isAuthenticated()) {
      this.auth.login();
      return;
    }

    this.modalService
      .open(content, {
        ariaLabelledBy: 'modal-basic-title'
      })
      .result.then(
        () => {
          this.submit();
        },
        reason => {
          console.debug(reason);
        }
      )
      .finally(() => {
        this.mobileScrollService.toggleSuggestion(false);
      });

    this.mobileScrollService.toggleSuggestion(true);
  }

  submit() {
    const props = {
      prettyName: this.metricPrettyName,
      metricId: this.metricId,
      description: this.description.substring(0, 1000),
      type: this.type,
      id: this.id
    };

    this.tracking.eventTrack('metric_feedback', props);

    // defer clear so that Submit will close the modal rather than getting immediately disabled
    setTimeout(() => (this.email = this.description = ''), 300);
  }
}
